import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';
import {
  AllocationViewTruckLeftAction,
  AllocationViewTruckLeftActionSetInitialState,
} from './allocation-view-truck-left-action.actions';
import { AllocationViewTruckLeftActionService } from './allocation-view-truck-left-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewTruckLeftActionStateModel {
  loaded: boolean;
}

const initialValue: AllocationViewTruckLeftActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsTruckLeft',
  defaults: initialValue,
})
@Injectable()
export class AllocationViewTruckLeftActionState extends AllocationViewActionBaseState {
  static getLoaded(state: AllocationViewTruckLeftActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewTruckLeftActionService: AllocationViewTruckLeftActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewTruckLeftAction)
  truckLeft(
    ctx: StateContext<AllocationViewTruckLeftActionStateModel>,
    { payload: { identifier } }: AllocationViewTruckLeftAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewTruckLeftActionService.truckLeft(identifier).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.truckLeft');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewTruckLeftActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewTruckLeftActionStateModel>): void {
    ctx.setState(initialValue);
    this.setContainerAfterActionEffectsInitialState();
  }
}
